
// הזנת ערכים בדאטה בייס
async function addDataToIndexedDB(databaseName, storeName, data) {
  return new Promise((resolve, reject) => {
    // פתיחה של חיבור לדאטהבייס
    const request = indexedDB.open(databaseName);

    request.onerror = () => {
      console.error('Failed to open the database.');
      reject('Failed to open the database.');
    };

    request.onsuccess = (event) => {
      const db = event.target.result;

      // הוספת מאזין לאירוע onversionchange
      db.onversionchange = () => {
        console.warn('Database version has changed. Closing the connection.');
        db.close(); // סגירת החיבור כדי למנוע קונפליקטים
        alert('Database has been updated in another tab. Please reload the page.');
      };

      // בדיקה אם הטבלה קיימת בדאטהבייס
      if (!db.objectStoreNames.contains(storeName)) {
        console.warn(`Store "${storeName}" does not exist in the database.`);
        reject(`Store "${storeName}" does not exist in the database.`);
        return;
      }

      // פתיחת טרנזקציה לצורך הוספת או עדכון נתונים
      const transaction = db.transaction(storeName, 'readwrite');
      const objectStore = transaction.objectStore(storeName);

      // אם data הוא מערך של אובייקטים, נבצע לולאה ונעדכן או נוסיף כל אובייקט בנפרד
      if (Array.isArray(data)) {
        data.forEach((item) => {
          const putRequest = objectStore.put(item); // שימוש ב-put לעדכון או הוספה

          putRequest.onerror = () => {
            console.error('Failed to add or update item:', item);
          };

          putRequest.onsuccess = () => {
            // console.log('Item added or updated successfully:', item);
          };
        });
      } else {
        // במידה וזהו אובייקט יחיד, נכניס אותו ישירות
        const putRequest = objectStore.put(data); // שימוש ב-put לעדכון או הוספה

        putRequest.onerror = () => {
          console.error('Failed to add or update item:', data);
        };

        putRequest.onsuccess = () => {
          // console.log('Item added or updated successfully:', data);
        };
      }

      // סיום הטרנזקציה
      transaction.oncomplete = () => {
        // console.log('All data added or updated successfully.');
        resolve('All data added or updated successfully.');
      };

      transaction.onerror = () => {
        console.error('Transaction failed.');
        reject('Transaction failed.');
      };
    };

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(storeName)) {
        db.createObjectStore(storeName, { keyPath: 'id', autoIncrement: true });
      }
    };
  });
}


function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

// קבלת ערכים מדאטה בייס לוקלי
export async function getTableData(databaseName, tableName) {
  return new Promise((resolve, reject) => {
    // פתיחה של חיבור לדאטה בייס
    const request = indexedDB.open(databaseName);
    request.onerror = () => {
      console.error('Failed to open the database.');
      resolve(null);
    };

    request.onsuccess = (event) => {
      const db = event.target.result;

      // בדיקה אם הטבלה קיימת בדאטה בייס
      if (!db.objectStoreNames.contains(tableName)) {
        console.warn(`Table "${tableName}" does not exist in the database.`);
        resolve(null);
        return;
      }

      const transaction = db.transaction(tableName, 'readonly');
      const objectStore = transaction.objectStore(tableName);
      const getAllRequest = objectStore.getAll();

      getAllRequest.onsuccess = () => {
        resolve(getAllRequest.result); // החזרת כל הערכים במערך
      };

      getAllRequest.onerror = () => {
        console.error(`Failed to retrieve data from table "${tableName}".`);
        resolve(null);
      };
    };

    request.onupgradeneeded = () => {
      console.warn('Database structure needs upgrading. Make sure the table exists.');
    };
  });
}

export const createFetchDataServer = (context) => {
  return async (tables = [], token, onPartialUpdate = null) => {
    // חילוץ הקונטקסט
    const {
      setContextCemeteries,
      setContextBlocks,
      setContextPlots,
      setContextRows,
      setContextAreaGraves,
      setContextGraves,
      setContextCustomers,
      setContextPurchases,
      setContextBurials,
      setContextCountries,
      setContextCities,
      setContextPayments,
      setContextSignatures,
      setContextPurchasesOld,
      setContextResidencies
    } = context;

    // מיפוי הגדרות הטבלאות
    const tableConfigs = {
      cemeteries: {
        nameDB: 'dataCemeteries',
        numDB: 1,
        setData: setContextCemeteries
      },
      blocks: {
        nameDB: 'dataBlocks',
        numDB: 2,
        setData: setContextBlocks
      },
      plots: {
        nameDB: 'dataPlots',
        numDB: 3,
        setData: setContextPlots
      },
      rows: {
        nameDB: 'dataRows',
        numDB: 4,
        setData: setContextRows
      },
      areaGraves: {
        nameDB: 'dataAreaGraves',
        numDB: 5,
        setData: setContextAreaGraves
      },
      graves: {
        nameDB: 'dataGraves',
        numDB: 6,
        setData: setContextGraves
      },
      customers: {
        nameDB: 'dataCustomers',
        numDB: 7,
        setData: setContextCustomers
      },
      purchases: {
        nameDB: 'dataPurchases',
        numDB: 8,
        setData: setContextPurchases
      },
      burials: {
        nameDB: 'dataBurials',
        numDB: 9,
        setData: setContextBurials
      },
      countries: {
        nameDB: 'dataCountries',
        numDB: 10,
        setData: setContextCountries
      },
      cities: {
        nameDB: 'dataCities',
        numDB: 11,
        setData: setContextCities
      },
      payments: {
        nameDB: 'dataPayments',
        numDB: 12,
        setData: setContextPayments
      },
      signatures: {
        nameDB: 'dataSignatures',
        numDB: 13,
        setData: setContextSignatures
      },
      purchasesOld: {
        nameDB: 'dataPurchasesOld',
        numDB: 14,
        setData: setContextPurchasesOld
      },
      residencies: {
        nameDB: 'dataResidencies',
        numDB: 15,
        setData: setContextResidencies
      }
    };

    let temp = null

    // יצירת הבטחות לשליפת כל טבלה
    const promises = tables.map((tableName) => {
      const config = tableConfigs[tableName];

      if (!config) {
        console.warn(`Table ${tableName} is not configured.`);
        return Promise.resolve();
      }

      const { nameDB, numDB, setData } = config;

      temp = config

      // קריאה לפונקציה לשליפת נתונים
      return fetchDataFromServerFull(
        token,
        tableName,
        setData,
        nameDB,
        numDB,
        20_000, // גודל החבילה
        null, // לא משתמשים בקולבק ישיר כאן
        onPartialUpdate // עדכון חלקי אם נדרש
      );
    });

    try {
      await Promise.all(promises);
      console.log('All selected tables have been fetched.');
    } catch (error) {
      console.error('Error fetching data for selected tables:', error);
      console.log('data:', temp);
      
    }
  };
};

const fetchDataFromServerFull = async (
  token,
  tableName,
  setData = () => {},
  nameDB,
  numDB,
  amountData = 0,
  callback = null, // קולבק אופציונלי
  onPartialUpdate = null // עדכון חלקי אופציונלי
) => {

  let temp = null

  try {
    temp = nameDB
    const totalRecordsResponse = await fetch('http://localhost:3001/api/test/getTest4', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        token: token,
        tableName: tableName,
        offset: 0,
        limit: 1,
        orderBy: 'id',
        // orderDirection: 'DESC'
      })
    });

    
    
    const { totalRecords: serverTotalRecords } = await totalRecordsResponse.json();
    const numIterations = Math.ceil(serverTotalRecords / amountData);
    
    let tempAllData = [];
    let currentOffset = 0;
    
    for (let i = 0; i < numIterations; i++) {
      const response = await fetch('http://localhost:3001/api/test/getTest4', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          token: token,
          tableName: tableName,
          offset: currentOffset,
          limit: amountData,
          orderBy: 'id',
          // orderDirection: 'DESC'
        })
      });
      
      const { data: newData } = await response.json();
      
      tempAllData = [
        ...new Map(
          [...tempAllData, ...mergeServerData(newData, nameDB)].map((item) => [item.unicId, item])
        ).values()
      ];
      
      
            // if (nameDB ==='dataSignatures') {
            //   console.log(279, tempAllData);
            // }
      
      
      // עדכון הסטייט עם הנתונים המסוננים
      if (typeof setData === 'function') {
        setData((prev) => {
        
          // יצירת Map לכל הערכים הקיימים ב-prev לפי unicId
          const prevMap = new Map(prev.map((item) => [item.unicId, item]));
        
          // הוספה/עדכון של הערכים החדשים מתוך mergeServerData
          mergeServerData(newData, nameDB).forEach((item) => {
            prevMap.set(item.unicId, { ...prevMap.get(item.unicId), ...item });
          });
        
          // המרת Map למערך
          const mergedData = Array.from(prevMap.values());

          // החזרת המערך המעודכן
          return mergedData;
        });   
      }

      // קריאה לעדכון חלקי אם מוגדר
      if (i === 0 && typeof onPartialUpdate === 'function') {
        onPartialUpdate(tableName);
      }

      currentOffset += amountData;

      const myData = [{ id: numDB, name: nameDB, value: tempAllData }];
      await addDataToIndexedDB('myDatabase', 'myStore', myData).catch((error) => console.error(error));

      if (i < numIterations - 1) {
        await sleep(50);
      }
    }

    // קריאה לקולבק אם מוגדר
    if (typeof callback === 'function') {
      callback(tempAllData);
    }
  } catch (error) {
    console.error('Error fetching data from server:', error);
    console.log('nameDB:', nameDB);
    
    // במקרה של שגיאה, קריאה לקולבק עם null
    if (typeof callback === 'function') {
      callback(null);
    }
  }
};

// -------------------------------------------------------------------------------
// פונקציה לטעינת localCache מ-localStorage
const loadLocalCache = () => {
  const localCache = localStorage.getItem('localCache');
  if (localCache) {
    const parsedCache = JSON.parse(localCache);
    return {
      added: parsedCache.added || {}, // אובייקט שבו כל מפתח הוא שם הטבלה ומכיל רשומות שנוספו
      updated: parsedCache.updated || {}, // אובייקט שבו כל מפתח הוא שם הטבלה ומכיל רשומות שעודכנו
      // deleted: parsedCache.deleted || {} // אובייקט שבו כל מפתח הוא שם הטבלה ומכיל מערך unicId שנמחקו
      deleted: Object.fromEntries(
        Object.entries(parsedCache.deleted || {}).map(([tableName, deletedArray]) => [tableName, new Set(deletedArray)])
      ) // המרה ל-Set
    };
  }

  // אם אין localCache ב-localStorage, מחזירים ערך ברירת מחדל
  return {
    added: {}, // מבנה לפי שם הטבלה
    updated: {},
    deleted: {}
  };
};

// פונקציה לשמירת localCache ל-localStorage
const saveLocalCache = (cache) => {
  const serializedCache = {
    ...cache,
    deleted: Object.fromEntries(
      Object.entries(cache.deleted).map(([tableName, deletedSet]) => [tableName, Array.from(deletedSet)])
    ) // המרה ממערכים של Set למערך רגיל
  };
  localStorage.setItem('localCache', JSON.stringify(serializedCache));
};

export const addRecordToCache = (record, tableName) => {
  const localCache = loadLocalCache();
  if (!localCache?.added[tableName]) {
    localCache.added[tableName] = [];
  }

  // הוספת timestamp לאייטם
  const recordWithTimestamp = { ...record, timestamp: new Date().toISOString() };

  // הסרת אייטמים ישנים עם אותו `unicId`
  localCache.added[tableName] = localCache.added[tableName].filter(
    (item) => item.unicId !== record.unicId
  );

  // הוספת האייטם החדש
  localCache.added[tableName].push(recordWithTimestamp);
  saveLocalCache(localCache);
};

export const updateRecordInCache = (updatedRecord, tableName) => {
  const localCache = loadLocalCache();
  if (!localCache.updated[tableName]) {
    localCache.updated[tableName] = {};
  }

  // הוספת timestamp לעדכון
  const recordWithTimestamp = { ...updatedRecord, timestamp: new Date().toISOString() };

  // הסרת אייטם ישן עם אותו unicId
  delete localCache.updated[tableName][updatedRecord.unicId];

  // הוספת האייטם המעודכן
  localCache.updated[tableName][updatedRecord.unicId] = recordWithTimestamp;

  saveLocalCache(localCache);
};

// פונקציה למחיקת רשומה ב-localCache
export const deleteRecordFromCache = (record, tableName) => {
  const localCache = loadLocalCache();

  // אם הטבלה לא קיימת, ניצור Set חדש
  if (!localCache.deleted[tableName]) {
    localCache.deleted[tableName] = new Set();
  }

  // הוספת ה-unicId של הרשומה ל-Set
  localCache.deleted[tableName].add(record.unicId);

  // שמירת השינויים ב-localStorage
  saveLocalCache(localCache);
};

// פונקציה לאיחוד הנתונים עם נתוני השרת
const mergeServerData = (serverData, tableName) => {
  const localCache = loadLocalCache();

  const tableAddedData = localCache.added[tableName] || [];
  const tableUpdatedData = localCache.updated[tableName] || {};
  const tableDeletedData = localCache.deleted[tableName] || new Set();

  const mergedData = serverData
    ?.filter((item) => !tableDeletedData.has(item?.unicId)) // מסנן רשומות שנמחקו
    ?.map((item) =>
      tableUpdatedData[item.unicId]
        ? { ...item, ...tableUpdatedData[item.unicId] } // מעדכן עם נתוני הלקוח
        : item
    );

  // הוספת רשומות חדשות רק אם unicId לא קיים בנתונים הקיימים
  const addedData = tableAddedData.filter((addedItem) => !mergedData.some((existingItem) => existingItem.unicId === addedItem.unicId));

  // שילוב הרשומות
  return mergedData?.concat(addedData);
};